import React from 'react';

const CreditByPortfolio = () => {
  return (
    <div className="container py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-semibold mb-6">Credit By Portfolio</h1>
        
        <div className="space-y-8">
          {/* Application Process Section */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold mb-4">Application Process</h2>
            <ul className="space-y-4">
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">1</span>
                <p>
                  Complete the Application for Credit form, noting the course description(s) from the course description
                  list for the course(s) for which you are seeking credit. All of the materials gathered for the portfolio should
                  demonstrate your knowledge of the various elements of the course description(s). The materials gathered must
                  reflect your personal experience and be prepared by you.
                </p>
              </li>
              
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">2</span>
                <p>
                  The resume form should give the evaluator an outline of your background and a summary overview of your
                  experience. Make it as complete as possible so the evaluator can have a good understanding of who you are and
                  what you have done.
                </p>
              </li>
              
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">3</span>
                <p>
                  If the Admissions and Registrar Department does not have a complete file of your transcripts, include them
                  in your portfolio. It is important that the evaluator be able to see all of the academic work you have done which
                  may relate to the credit being sought.
                </p>
              </li>
              
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">4</span>
                <p>
                  List the courses, workshops and seminars you have attended which relate directly to the course(s) for which
                  credit is being sought. Do not list unrelated events. Describe the nature of the subjects discussed, the length of
                  the sessions and any other information which will fully explain the nature of the event. Attach documentation of
                  your attendance (programs, attendance certificates, CEU certifications, brochures, etc.).
                </p>
              </li>
              
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">5</span>
                <p>
                  In the bibliography list any books which you have read and which directly relate to the course. Do not list
                  books you have in your library that you have not read.
                </p>
              </li>
              
              <li className="flex gap-4">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center">6</span>
                <p>
                  Send two copies of the completed portfolio to the Dean of your school/college and the Admissions and
                  Registrar Department at the address listed on the front page. You will be sent an updated transcript based on the
                  evaluation of your portfolio.
                </p>
              </li>
            </ul>
          </section>

          {/* Portfolio Requirements Section */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold mb-4">Portfolio Requirements</h2>
            <div className="space-y-4 bg-gray-50 p-6 rounded-lg">
              <div className="space-y-3">
                <h3 className="font-semibold">Academic Requirements</h3>
                <p>
                  Academic Requirements of Hamilton College of the Bahamas are listed in
                  the catalogue or under the requirements for degrees.
                </p>
              </div>

              <div className="space-y-3">
                <h3 className="font-semibold">Resume (Attachment A)</h3>
                <p>
                  The resume provides an outline of personal, educational, military, employment and ministerial
                  background. Consider it to be an introduction to the portfolio which will be used as a reference by the
                  evaluator when reviewing the other sections.
                </p>
              </div>

              <div className="space-y-3">
                <h3 className="font-semibold">Transcripts (Attachment B)</h3>
                <p>
                  If the Admissions and Registrar do not have a complete file or transcripts of your
                  academic work, attach them to the portfolio package.
                </p>
              </div>

              <div className="space-y-3">
                <h3 className="font-semibold">Professional Courses/Workshops/Seminars (Attachment C)</h3>
                <p>
                  List those courses, workshops, and/or seminars in which you have participated and which relate 
                  to the course for which you are seeking credit. Attach documentation of your attendance.
                </p>
              </div>

              <div className="space-y-3">
                <h3 className="font-semibold">Bibliography (Attachment D)</h3>
                <p>
                  List the books which have been thoroughly read and which relate to the course for which
                  you are seeking credit. Include each book's title, author, publisher, copyright date and brief 
                  description. You may be required to take a test on the book(s) if credit is to be awarded.
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CreditByPortfolio; 